export const getIsConnected = (state) => state.globalStateReducer.isConnected;
export const getIsOffline = (state) => state.globalStateReducer.isOffline;
export const getIsMinimize = (state) => state.globalStateReducer.isMinimize;
export const getOnCall = (state) => state.globalStateReducer.onCall;
export const getSelectedTab = (state) => state.globalStateReducer.selectedTab;
export const getState = (state) => state.globalStateReducer.state;
export const getDynamic = (state, options) => {
  if (options.key) {
    let value = state.globalStateReducer[options.key];
    return value;
  } else {
    return '';
  }
};
export const getPermission = (state, key) => {
  const accessDefination = state.globalStateReducer.accessDefination;
  if (
    accessDefination &&
    accessDefination[key] &&
    accessDefination[key].options
  ) {
    return accessDefination[key].options;
  }

  return;
};



// WEBPACK FOOTER //
// src/store/selector/globalState.selector.js